var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('payslip-ea-form',{attrs:{"employee-uid":_vm.employee.employee_uid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }